import {useQueries} from "@tanstack/react-query";
import garrisonAuditService from "../../../../../services/reports/garrison-audit-service.js";

const UseFetchOptions = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['garrisonLeader'],
                queryFn: () => garrisonAuditService.getAllByNameWarAudit(),
                initialData: []
            }
        ]
    });

    return {
        garrisonLeader: queries[0].data
    }
}

export default UseFetchOptions;